export default __webpack_public_path__ + "static/media/kumho.00fb7c27.png";